<template>
    <div>
        <div class="flex flex-col gap-4 items-center justify-center mb-5">
            <a
                class="w-full px-4 py-3 flex items-center gap-4 hover:opacity-50 transition-opacity rounded shadow border border-slate-200 font-semibold text-slate-800"
                href="/login/facebook"
            >
                <span class="text-[#5e73df]">
                    <svg
                        width="23"
                        height="23"
                        viewBox="0 0 23 23"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            id="path14"
                            d="M22.0418 11.5625C22.0418 5.74046 17.3222 1.0208 11.5002 1.0208C5.67816 1.0208 0.958496 5.74046 0.958496 11.5625C0.958496 16.8241 4.81343 21.1852 9.85303 21.9761V14.6097H7.17643V11.5625H9.85303V9.24001C9.85303 6.598 11.4268 5.13864 13.8348 5.13864C14.9881 5.13864 16.1945 5.34453 16.1945 5.34453V7.93877H14.8652C13.5557 7.93877 13.1473 8.75136 13.1473 9.58502V11.5625H16.071L15.6036 14.6097H13.1473V21.9761C18.1869 21.1852 22.0418 16.8241 22.0418 11.5625Z"
                            fill="#5374E5"
                        />
                    </svg>
                </span>
                Continue with Facebook
            </a>
            <a
                class="w-full px-4 py-3 flex items-center gap-4 hover:opacity-50 transition-opacity rounded shadow border border-slate-200 font-semibold text-slate-800"
                href="/login/google"
            >
                <img
                    src="/images/google-g.svg"
                    width="22"
                    height="22"
                    alt="Sign in with Google"
                />
                Continue with Google
            </a>
        </div>
    </div>
</template>
<script setup></script>
